<template lang="pug">
  #challenge-edit
    WtTile(ancestor vertical)
      WtTile(parent)
        WtTile
          .level.challenge-edit-header
            .level-left
              .level-item
                WtTitle(h1) {{ editedChallenge.name }}
            .level-right
              .level-item(v-if="isAdminEdit")
                WtButton(isRouterLink :to="{ name: 'ChallengeCenterSettings' }" color="primary") BACK TO CHALLENGE CENTER
              .level-item(v-else)
                WtButton(
                  @click.native="$router.back()"
                  color="primary"
                ) {{ backToText }}

      WtTile(parent vertical)
        WtTile(child :is-loading="challengeEditLoading")
          .level
            .level-left
              .level-item
                WtTitle(h3) Edit Challenge Details
            .level-right
              .level-item(v-if="isAdminEdit")
                WtButton(
                  isRouterLink
                  :to="{ name: 'Challenge', params: { challengeId: challengeId } }"
                  color="primary"
                ) VIEW CHALLENGE
              WtActionMenu
                WtActionMenuItem.delete-challenge.has-text-danger(
                  icon="delete"
                  text="Delete challenge"
                  @click.native="deleteChallengeWrapper(originalChallenge.id)"
                )

          .card
            .columns
              .column.is-half
                // Challenge Name
                BField
                  //- TODO don't want UniquenessCheck with starting value to trigger validation, v-if is a workaround
                  UniquenessCheck(
                    v-if="!challengeEditLoading"
                    label="Challenge Name"
                    entity="challengeName"
                    placeholder="My Awesome Challenge"
                    v-model="editedChallenge.name"
                    :disabled="isComplete"
                    @input="disableSave = isOriginalValue('name', editedChallenge.name)"
                  )
              // STEP GOAL
              .column.is-half(v-if="!challengeEditLoading")
                BField(
                  v-if="!(isWellnessChallenge || isPreventativeChallenge)"
                  label="Daily Step Goal"
                )
                  BInput(
                    name="daily step goal"
                    v-model="editedChallenge.dailyStepGoal"
                    :disabled="isComplete"
                    @input="disableSave = isOriginalValue('dailyStepGoal', editedChallenge.dailyStepGoal)"
                  )

            ChallengeDates(
              isChallengeEdit
              :original-challenge="originalChallenge"
              :edited-challenge="editedChallenge"
              :featured="Boolean(editedChallenge.featured)"
              @durationInputEvent="durationInputEvent"
              @startDateInputEvent="startDateInputEvent"
              @endDateInputEvent="endDateInputEvent"
            )

          WtTitle(h3) Challenge Settings
          .card(v-if="!challengeEditLoading")
            .columns
              template(v-if="isWellnessChallenge")
                .column.is-half
                  // Allow Journal Entry and Questions Points
                  template(v-if="!isCustomWellnessChallenge")
                    BField(label="Allow points for:")
                      .is-flex.is-flex-direction-column
                        .is-flex
                          BCheckbox(
                            v-model="editedChallenge.isTrackingTextAndImage"
                            :true-value="1"
                            :false-value="0"
                            @input="disableSave = isOriginalValue('isTrackingTextAndImage', editedChallenge.isTrackingTextAndImage)"
                          )
                            | Journal Entries
                          BTooltip(
                            label="Journal Entry and Photo points."
                            position="is-top"
                            animated
                            type="is-light"
                          )
                            BIcon(icon="help-circle-outline" size="is-small")
                        .is-flex
                          BCheckbox(
                            v-model="editedChallenge.isTrackingQuestions"
                            :true-value="1"
                            :false-value="0"
                            @input="disableSave = isOriginalValue('isTrackingQuestions', editedChallenge.isTrackingQuestions)"
                          )
                            | Questions
                          BTooltip(
                            label="Question points."
                            position="is-top"
                            animated
                            type="is-light"
                          )
                            BIcon(icon="help-circle-outline" size="is-small")
              template(v-if="!isWellnessChallenge")
                .column.is-half(v-if="(isAdminEdit || isAdmin) && !editedChallenge.featured")
                  // INVITE ONLY
                  WtRadioQuestionInput.block(
                    v-if="!editedChallenge.featured && !isPreventativeChallenge"
                    label="Who can see and join this challenge?"
                  )
                    template(v-slot:radioOne)
                      BRadio.define-radio(
                        v-model="editedChallenge.publicAndOpen"
                        :native-value="1"
                        @input="disableSave = isOriginalValue('publicAndOpen', editedChallenge.publicAndOpen)"
                        :disabled="isComplete"
                      )
                        | All members
                    template(v-slot:radioTwo)
                      BRadio.define-radio(
                        v-model="editedChallenge.publicAndOpen"
                        :native-value="0"
                        @input="disableSave = isOriginalValue('publicAndOpen', editedChallenge.publicAndOpen)"
                        :disabled="isComplete"
                      )
                        | Selected members only
                .column.is-half
                  // TRACKING
                  WtRadioQuestionInput(
                    label="What To Track:"
                    v-if="!isPreventativeChallenge"
                  )
                    template(v-slot:radioOne)
                      BRadio.define-radio(
                        v-model="editedChallenge.allowActivities"
                        :native-value="stepsValue"
                        @input="disableSave = isOriginalValue('allowActivities', editedChallenge.allowActivities)"
                        :disabled="isComplete"
                      )
                        | Steps
                    template(v-slot:radioTwo)
                      BRadio.define-radio(
                        v-model="editedChallenge.allowActivities"
                        :native-value="activitiesValue"
                        @input="disableSave = isOriginalValue('allowActivities', editedChallenge.allowActivities)"
                        :disabled="isComplete || !coreProgramMeta.converter"
                      )
                        | Activities
                    template(v-slot:radioThree)
                      BRadio.define-radio(
                        v-model="editedChallenge.allowActivities"
                        :native-value="stepsAndActivitiesValue"
                        @input="disableSave = isOriginalValue('allowActivities', editedChallenge.allowActivities)"
                        :disabled="isComplete || !coreProgramMeta.converter"
                      )
                        | Steps & Activities
            template(v-if="!isWellnessChallenge")
              // Featured challenge
              p.has-text-danger(v-if="$auth.user().isWtAdmin") * WT-admins can toggle featured if the challenge has started.
              WtSwitchQuestionInput.block(
                label="Is this a featured challenge?"
                v-model="editedChallenge.featured"
                @input="disableSave = isOriginalValue('featured', editedChallenge.featured)"
                :disabled="challengeStarted && !$auth.user().isWtAdmin"
              )
            .columns
              .column(v-if="!challengeEditLoading")
                BField(
                  v-if="!isWellnessChallenge"
                  label="Challenge Details"
                )
                  WtDisplayRichTextHTML(
                    v-if="isComplete"
                    :html="editedChallenge.atStake"
                  )
                  WtWysiwyg#atStake(
                    v-else
                    selector="#atStake"
                    :content.sync="editedChallenge.atStake"
                    @update:content="$nextTick(() => disableSave = isOriginalValue('atStake', editedChallenge.atStake))"

                  )
          WtTile(parent v-if="showIncentiveSettings")
            WtTile(child child-class="")
              WtTitle(h3) Incentive Settings
                WtTooltip(:text="incentiveTooltip")
          WtTile(padding="large" v-if="showIncentiveSettings")
            WtTile(vertical)
              WtTile(parent :col="12")
                WtTile(child :col="12" child-class="")
                  WtSwitchQuestionInput.block(
                    label="Incentivize this challenge?"
                    v-model="editedChallenge.incentivizeChallenge"
                    @input="disableSave = isOriginalValue('incentivizeChallenge', editedChallenge.incentivizeChallenge)"
                    :disabled="challengeStarted && !$auth.user().isWtAdmin"
                  )
              WtTile(parent :col="12")
                WtTile(child :col="8" child-class="")
                  WtRadioQuestionInput.block(
                    label="Incentive Type"
                  )
                    template(v-slot:radioOne)
                      BRadio.define-radio(
                        v-model="editedChallenge.incentiveType"
                        native-value="split"
                        @input="disableSave = isOriginalValue('incentiveType', editedChallenge.incentiveType)"
                        :disabled="!editedChallenge.incentivizeChallenge || challengeStarted"
                      ) Split incentive equally among all members who meet the challenge goal.
                      br
                    template(v-slot:radioTwo)
                      BRadio.define-radio(
                        v-model="editedChallenge.incentiveType"
                        native-value="award"
                        @input="disableSave = isOriginalValue('incentiveType', editedChallenge.incentiveType)"
                        :disabled="!editedChallenge.incentivizeChallenge || challengeStarted"
                      ) Award set amount for all members who meet the challenge goal.
              .column
                WtTile(child :col="1" child-class="")
                WtTile(child :col="4" child-class="")
                  BField(
                    label="Incentive Amount"
                  )
                    BField.is-marginless
                      BInput(
                        v-model="editedChallenge.incentiveAmount"
                        v-validate="'required'"
                        type="number"
                        :disabled="!editedChallenge.incentivizeChallenge || challengeStarted"
                      )
                br
          // these buttons are used twice on the page - beware when editing to edit the duplicate snippet
          .challenge-edit-form-controls
            .level.is-mobile
              .level-left
                .level-item
                  WtButton(
                    is-text
                    color="lightgrey"
                    size="medium"
                    @click.native="setLocalData()"
                  ) RESET
                .level-item
                  WtButton(
                    color="primary"
                    size="large"
                    @click.native="saveChanges"
                    :disabled="disableSave"
                    :loading="saveInProgress"
                  ) SAVE CHANGES

        WtTile(child :is-loading="challengeEditLoading")
          WtTitle(h3) {{ originalChallenge.between === 'groups' ? "Challenge Teams" : "Challenge Members" }}
          .card
            ChallengeEntities(
              v-if="editedChallenge.id"
              :key="'ChallengeEntities'+forceReloadOfChallengeEntities"
              :challenge="editedChallenge"
              :challenge-complete="isComplete"
              :removeTeamCallback="removeTeamCallback"
            )

          span(v-if="!isComplete && originalChallenge.between === 'individuals'")
            WtTitle(h3) Include Members
            .card
              .notification.is-warning {{ inviteAllEntitiesNote }}
              h3(v-if="entitiesLoaded") {{ addAllEntitiesNote }}
              br
              BField
                BRadio(size="is-large" v-model="includeByType" native-value="invite") Invite Members
                template(v-if="!isAdmin")
                  WtButton(
                    outlined
                    color="primary"
                    @click.native="includeEntityTableOpen = !includeEntityTableOpen"
                  )
                    BIcon(slot="icon" :icon="includeEntityTableOpen ? 'chevron-up' : 'chevron-down'")
                    span Show Members
              template(v-if="isAdmin")
                BField
                  BRadio(size="is-large" v-model="includeByType" native-value="add") Add Members
                br
                BField(:label="includeByType === 'invite' ? 'Invite All Members Now:' : 'Add All Members Now:'" horizontal)
                  WtButton(
                    outlined
                    color="primary"
                    @click.native="includeByType === 'invite' ? inviteAllMembersWrapper() : addAllMembersWrapper()"
                    :disabled="includeAllEntitiesButtonDisabled"
                    :loading="includingAllEntitiesInProgress"
                  )
                    BIcon(slot="icon" icon="email-outline")
                    span {{ includeAllEntitiesButtonText }}
                .level
                BField(:label="includeByType === 'invite' ? 'Invite Select Members:' : 'Add Select Members:'" horizontal)
                  WtButton(
                    outlined
                    color="primary"
                    @click.native="includeEntityTableOpen = !includeEntityTableOpen"
                  )
                    BIcon(slot="icon" :icon="includeEntityTableOpen ? 'chevron-up' : 'chevron-down'")
                    span Show Members
              ChallengeIncludeMembers(
                v-show="includeEntityTableOpen"
                title=""
                :tooltip-text="includeMembersTooltip"
                :open-toggle="includeEntityTableOpen"
                :loaded="membersLoaded"
                @search="onSearch($event)"
                @toggle="onToggleInvites($event)"
                :includeByType="includeByType"
                :notInChallengeId="parseInt(challengeId)"
              )
          span(v-if="!isComplete && originalChallenge.between === 'groups'")
            WtTitle(h3) Include Teams
            .card
              .notification.is-warning {{ inviteAllEntitiesNote }}
              h3(v-if="entitiesLoaded") {{ addAllEntitiesNote }}
              br
              BField
                BRadio(size="is-large" v-model="includeByType" native-value="invite") Invite Teams
                template(v-if="!isAdmin")
                  WtButton(
                    outlined
                    color="primary"
                    @click.native="includeEntityTableOpen = !includeEntityTableOpen"
                  )
                    BIcon(slot="icon" :icon="includeEntityTableOpen ? 'chevron-up' : 'chevron-down'")
                    span Show Teams
              template(v-if="isAdmin")
                BField
                  BRadio(size="is-large" v-model="includeByType" native-value="add") Add Teams
                br
                BField(:label="includeByType === 'invite' ? 'Invite All Teams Now:' : 'Add All Teams Now:'" horizontal)
                  WtButton(
                    outlined
                    color="primary"
                    @click.native="includeByType === 'invite' ? inviteAllTeamsWrapper() : addAllTeamsWrapper()"
                    :disabled="includeAllEntitiesButtonDisabled"
                    :loading="includingAllEntitiesInProgress"
                  )
                    BIcon(slot="icon" icon="email-outline")
                    span {{ includeAllEntitiesButtonText }}
                .level
                BField(:label="includeByType === 'invite' ? 'Invite Select Teams:' : 'Add Select Teams:'" horizontal)
                  WtButton(
                    outlined
                    color="primary"
                    @click.native="includeEntityTableOpen = !includeEntityTableOpen"
                  )
                    BIcon(slot="icon" :icon="includeEntityTableOpen ? 'chevron-up' : 'chevron-down'")
                    span Show Teams
              ChallengeIncludeTeams(
                v-show="includeEntityTableOpen"
                title=""
                :tooltip-text="includeGroupsTooltip"
                :open-toggle="includeEntityTableOpen"
                @toggle="onToggleInvites($event)"
                :loaded="true"
                :includeByType="includeByType"
                :notInChallengeId="parseInt(challengeId)"
                emptyMessage="No team left to add"
                :key="'challengeTeams'+forceReloadOfTeamTable"
              )
          // these buttons are used twice on the page - beware when editing to edit the duplicate snippet
          .challenge-edit-form-controls
            .level.is-mobile
              .level-left
                .level-item
                  WtButton(
                    is-text
                    color="lightgrey"
                    size="medium"
                    @click.native="setLocalData()"
                  ) RESET
                .level-item
                  WtButton(
                    color="primary"
                    size="large"
                    @click.native="saveChanges"
                    :disabled="disableSave"
                    :loading="saveInProgress"
                  ) SAVE CHANGES

</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import { numberUtilityMixin } from "@/mixins/numberUtilityMixin";
import WtActionMenu from "@@/WtActionMenu/WtActionMenu";
import WtActionMenuItem from "@@/WtActionMenuItem/WtActionMenuItem";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import WtButton from "@@/WtButton/WtButton";
import WtReadonlyInputControls from "@@/WtReadonlyInputControls/WtReadonlyInputControls";
import WtSwitchQuestionInput from "@@/WtSwitchQuestionInput/WtSwitchQuestionInput";
import WtRadioQuestionInput from "@@/WtRadioQuestionInput/WtRadioQuestionInput";
import WtTooltip from "@@/WtTooltip/WtTooltip";
import WtWysiwyg from "@@/WtWysiwyg/WtWysiwyg";
import WtDisplayRichTextHTML from "@@/WtDisplayRichTextHTML/WtDisplayRichTextHTML";
import UniquenessCheck from "@@/WtUniquenessCheckInput/WtUniquenessCheckInput";
import ChallengeIncludeMembers from "@@/Challenge/ChallengeIncludeMembers";
import ChallengeIncludeTeams from "@@/Challenge/ChallengeIncludeTeams";
import ChallengeEntities from "@@/Challenge/ChallengeEntities";
import ChallengeDates from "@@/ChallengeBuilder/ChallengeDates";
import DatePickerFooter from "@@/ChallengeBuilder/ChallengeBuilderDatePickerFooter";

const STEPS = 0;
const ACTIVITIES = 2;
const STEPS_AND_ACTIVITIES = 1;
const COMPLETED = 2;

export default {
  name: "ChallengeEdit",

  components: {
    ChallengeDates,
    ChallengeEntities,
    ChallengeIncludeMembers,
    ChallengeIncludeTeams,
    WtActionMenu,
    WtActionMenuItem,
    WtTile,
    WtTitle,
    WtButton,
    WtSwitchQuestionInput,
    WtRadioQuestionInput,
    WtReadonlyInputControls,
    WtTooltip,
    WtWysiwyg,
    WtDisplayRichTextHTML,
    UniquenessCheck,
    DatePickerFooter
  },

  mixins: [dateUtilityMixin, numberUtilityMixin],

  props: {
    challengeId: {
      type: [String, Number],
      required: true
    }
  },

  data() {
    return {
      challengeEditLoading: true,
      originalChallenge: {
        between: null
      },
      editedChallenge: {
        name: null,
        featured: null,
        between: null,
        duration: null,
        startDate: null,
        endDate: null,
        dailyStepGoal: null,
        open: null,
        public: null,
        publicAndOpen: null,
        allowActivities: null,
        atStake: null,
        isTrackingQuestions: null,
        isTrackingTextAndImage: null,
        incentivizeChallenge: null,
        incentiveType: null,
        incentiveAmount: null
      },
      stepsValue: STEPS,
      activitiesValue: ACTIVITIES,
      stepsAndActivitiesValue: STEPS_AND_ACTIVITIES,
      includingAllEntitiesInProgress: false,
      inviteAllEntitiesNote: "It looks like no invites have been sent yet.",
      addAllEntitiesNote: "",
      includeAllEntitiesButtonDisabled: false,
      saveInProgress: false,
      disableSave: true,
      fromRoute: "",
      includeEntityTableOpen: false,
      includeByType: "invite",
      entitiesLoaded: true, // TODO
      updateChallengeError: false,
      forceReloadOfChallengeEntities: 1,
      forceReloadOfTeamTable: 1
    };
  },

  computed: {
    ...mapGetters("program", [
      "coreProgramMeta",
      "allChallenges",
      "allChallengesLoaded",
      "membersLoaded",
      "programTeamsResponseObject",
      "featuredChallenges",
      "isIncentiveIntegrationOn"
    ]),
    ...mapGetters("challengeBuilder", ["stagedMembers", "stagedTeams"]),
    ...mapGetters("authMember", ["isAdmin"]),
    ...mapState("members", {
      memberChallenges: state => state.challenges
    }),
    ...mapState("program", {
      programChallenges: state => state.challenges
    }),

    isAdminEdit() {
      return /admin/.test(this.$route.path);
    },

    backToText() {
      return this.fromRoute === "Challenge"
        ? "BACK TO CHALLENGE"
        : "BACK TO ALL CHALLENGES";
    },

    isComplete() {
      return this.originalChallenge.status === COMPLETED;
    },

    includeAllEntitiesButtonText() {
      return this.includeByType === "invite" ? "INVITE ALL" : "ADD ALL";
    },

    includeMembersTooltip() {
      return `Click here to include all members you'd like to ${this.includeByType}, then click "save changes"`;
    },

    includeGroupsTooltip() {
      return `Click here to include all teams you'd like to ${this.includeByType}, then click "save changes"`;
    },

    canEdit() {
      return (
        this.isAdmin ||
        this.$auth.user().id === this.originalChallenge.initiator.id
      );
    },

    isWellnessChallenge() {
      return this.originalChallenge.isWellness;
    },

    isCustomWellnessChallenge() {
      return this.originalChallenge.isCustomWellness;
    },

    isPreventativeChallenge() {
      return this.originalChallenge.isPreventative;
    },

    challengeStarted() {
      return this.moment().isAfter(
        this.moment(this.originalChallenge.startDate)
      );
    },

    showIncentiveSettings() {
      return this.$auth.user().isAdmin && this.isIncentiveIntegrationOn;
    },
    incentiveTooltip() {
      if (!this.challengeStarted) {
        return `Changes to incentives can be made here up until the challenge start date.`;
      } else {
        return `This challenge has already started and no further changes can be made at this time.`;
      }
    }
  },

  watch: {
    stagedMembers() {
      if (this._.isEmpty(this.stagedMembers)) {
        this.disableSave = true;
        this.includeAllEntitiesButtonDisabled = false;
      } else {
        this.disableSave = false;
        this.includeAllEntitiesButtonDisabled = true;
      }
    },

    stagedTeams() {
      if (this._.isEmpty(this.stagedTeams)) {
        this.disableSave = true;
        this.includeAllEntitiesButtonDisabled = false;
      } else {
        this.disableSave = false;
        this.includeAllEntitiesButtonDisabled = true;
      }
    },

    "editedChallenge.publicAndOpen": function(value) {
      this.editedChallenge.open = value;
      this.editedChallenge.public = value;
    },

    "editedChallenge.featured": function(value) {
      if (value) {
        this.editedChallenge.featured = value;
      }
    },
    "editedChallenge.incentivizeChallenge": function(value) {
      if (value) {
        this.editedChallenge.incentivizeChallenge = value;
      }
      if (!this.editedChallenge.incentiveAmount) {
        this.disableSave = true;
      }
    },
    "editedChallenge.incentiveType": function(value) {
      if (value) {
        this.editedChallenge.incentiveType = value;
      }
      if (!this.editedChallenge.incentiveAmount) {
        this.disableSave = true;
      }
    },
    "editedChallenge.incentiveAmount": function(value) {
      if (value) {
        this.editedChallenge.incentiveAmount = value;
        this.disableSave = false;
      }
    }
  },

  async created() {
    //TODO fetchFeaturedChallenge now returns all featured challenges - rename to fetchFeaturedChallenges
    if (!this.featuredChallengesLoaded) {
      await this.fetchFeaturedChallenge(this.$auth.user().programId);
    }

    await this.setLocalData();

    let entities =
      this.originalChallenge.between === "groups" ? "teams" : "members";

    this.inviteAllEntitiesNote = `If new ${entities} joined your program since the last time invites were sent, \
        please, re-invite all ${entities} by clicking below.  \
        Note, ${entities} who have already received an invite will not be notified again, though their invite will still exist, allowing \
        them to join this challenge.`;

    this.challengeEditLoading = false;
  },

  methods: {
    ...mapActions("challenges", [
      "updateChallenge",
      "sentChallengeInvites",
      "deleteChallenge",
      "addEntitiesToChallenge",
      "fetchChallengeEntities"
    ]),
    ...mapActions("invites", [
      "inviteChallengeEntities",
      "inviteChallengeAllMembers",
      "inviteChallengeAllTeams"
    ]),
    ...mapActions("challengeBuilder", [
      "emptyStagedMembers",
      "emptyStagedTeams"
    ]),
    ...mapActions("program", [
      "searchMembers",
      "setMembersResponseObject",
      "fetchAllChallenges",
      "fetchProgramTeams",
      "fetchFeaturedChallenge"
    ]),
    ...mapActions("pages", ["setPageLoaded", "setPageLoading"]),
    ...mapActions(["snackBar"]),

    durationInputEvent($event) {
      this.disableSave = this.isOriginalValue("duration", $event);
    },

    startDateInputEvent($event) {
      this.disableSave = this.isOriginalValue("startDate", $event);
    },

    endDateInputEvent($event) {
      this.disableSave = this.isOriginalValue("endDate", $event);
    },

    async setLocalData() {
      // these getters are populated via the previous route `/admin/challenge-center/settings` or `challenges`
      let memberChallenges = this._.get(
        this.$auth.user(),
        "challenges",
        this.memberChallenges
      );
      if (this.allChallenges.length < 1) {
        await this.fetchAllChallenges({
          programId: this.$auth.user().programId
        });
      }
      let challenges = this.allChallenges;

      if (!this.isAdminEdit && !this.isAdmin) {
        challenges = [...memberChallenges, ...challenges];
      }

      this.originalChallenge = {
        ...this._.find(challenges, { id: +this.challengeId })
      };

      this.editedChallenge = Object.assign({}, this.editedChallenge, {
        id: this.originalChallenge.id,
        featured: this.originalChallenge.featured,
        between: this.originalChallenge.between,
        name: this.originalChallenge.name,
        duration: this.daysBetweenInclusive(
          this.originalChallenge.startDate,
          this.originalChallenge.endDate
        ),
        startDate: this.date(this.originalChallenge.startDate).dateObject,
        endDate: this.date(this.originalChallenge.endDate).dateObject,
        dailyStepGoal: this.originalChallenge.dailyStepGoal,
        open: this.originalChallenge.open,
        public: this.originalChallenge.public,
        publicAndOpen: this.originalChallenge.publicAndOpen,
        allowActivities: this.originalChallenge.allowActivities,
        atStake: this.originalChallenge.atStake,
        incentivizeChallenge: this.originalChallenge.incentivesOn,
        incentiveType: this.originalChallenge.incentivesType,
        incentiveAmount: this.originalChallenge.incentivesAmount
      });
      if (this.isWellnessChallenge) {
        this.editedChallenge = Object.assign({}, this.editedChallenge, {
          isTrackingTextAndImage: Number(
            this.originalChallenge.isTrackingTextAndImage
          ),
          isTrackingQuestions: Number(
            this.originalChallenge.isTrackingQuestions
          )
        });
      }

      this.includeEntityTableOpen = false;
      if (this.originalChallenge.between === "individuals") {
        this.emptyStagedMembers();
      }
      if (this.originalChallenge.between === "groups") {
        this.emptyStagedTeams();
        if (this._.isEmpty(this.programTeamsResponseObject)) {
          await this.fetchProgramTeams();
        }
      }

      this.onSearch = this._.debounce(async query => {
        const response = await this.searchMembers({
          programId: this.$auth.user().programId,
          query: query,
          perPage: 10,
          notInChallengeId: this.challengeId
        });
        this.setMembersResponseObject(response);
      }, 500);
    },

    isOriginalValue(attribute, newValue) {
      let oldValue = this.originalChallenge[attribute];

      if (
        attribute === "endDate" ||
        attribute === "startDate" ||
        attribute === "duration"
      ) {
        if (attribute === "duration") attribute = "endDate";
        return (
          this.date(this.originalChallenge[attribute]).formatted ===
          this.date(this.editedChallenge[attribute]).formatted
        );
      }

      return oldValue === newValue;
    },

    inviteAllMembersWrapper() {
      this.includeEntityTableOpen = false;
      this.$buefy.dialog.confirm({
        title: "Invite All Members To This Challenge",
        confirmText: "Invite All Members",
        type: "is-danger",
        hasIcon: true,
        message:
          "Are you sure you want to invite all Members to this Challenge?  *Note, this cannot be undone.",
        onConfirm: async () => {
          this.includingAllEntitiesInProgress = true;
          await this.inviteChallengeAllMembers(this.originalChallenge.id).then(
            response => {
              if (response && response.data.success) {
                this.inviteAllEntitiesNote =
                  "✔ Awesome, all program members have been invited to this challenge!";
                this.includeAllEntitiesButtonDisabled = true;
              }
            }
          );
          this.includingAllEntitiesInProgress = false;
        }
      });
    },

    addAllMembersWrapper() {
      this.includeEntityTableOpen = false;
      this.$buefy.dialog.confirm({
        title: "Add All Members To This Challenge",
        confirmText: "Add All Members",
        type: "is-danger",
        hasIcon: true,
        message:
          "Are you sure you want to add all members to this Challenge?  *Note, this cannot be undone.",
        onConfirm: async () => {
          this.includingAllEntitiesInProgress = true;
          await this.addEntitiesToChallenge({
            challenge: this.originalChallenge,
            includeAll: true
          }).then(response => {
            if (response && response.data.success) {
              this.addAllEntitiesNote =
                "✔ Awesome, all program members have been invited to this challenge!";
              this.includeAllEntitiesButtonDisabled = true;
            }
          });
          this.includingAllEntitiesInProgress = false;
        }
      });
    },

    inviteAllTeamsWrapper() {
      this.includeEntityTableOpen = false;
      this.$buefy.dialog.confirm({
        title: "Invite All Teams To This Challenge",
        confirmText: "Invite All Teams",
        type: "is-danger",
        hasIcon: true,
        message:
          "Are you sure you want to invite all Teams to this Challenge?  *Note, this cannot be undone.",
        onConfirm: async () => {
          this.includingAllEntitiesInProgress = true;
          await this.inviteChallengeAllTeams(this.originalChallenge.id).then(
            response => {
              if (response && response.data.success) {
                this.inviteAllEntitiesNote =
                  "✔ Awesome, all program teams have been invited to this challenge!";
                this.includeAllEntitiesButtonDisabled = true;
              }
            }
          );
          this.includingAllEntitiesInProgress = false;
        }
      });
    },

    addAllTeamsWrapper() {
      this.includeEntityTableOpen = false;
      this.$buefy.dialog.confirm({
        title: "Add All Teams To This Challenge",
        confirmText: "Add All Teams",
        type: "is-danger",
        hasIcon: true,
        message:
          "Are you sure you want to add all teams to this Challenge?  *Note, this cannot be undone.",
        onConfirm: async () => {
          this.includingAllEntitiesInProgress = true;
          await this.addEntitiesToChallenge({
            challenge: this.originalChallenge,
            includeAll: true
          }).then(response => {
            if (response && response.data.success) {
              this.addAllEntitiesNote =
                "✔ Awesome, all program teams have been added to this challenge!";
              this.includeAllEntitiesButtonDisabled = true;
            }
          });
          this.includingAllEntitiesInProgress = false;
        }
      });
    },

    deleteChallengeWrapper(challengeId) {
      this.$buefy.dialog.confirm({
        title: "Delete This Challenge",
        confirmText: "Delete This Challenge",
        type: "is-danger",
        hasIcon: true,
        message:
          "Are you sure you want to delete this challenge?  *Note, this cannot be undone.",
        onConfirm: async () => {
          await this.deleteChallenge(challengeId);
          this.setPageLoaded({ key: "MyDashboard", value: false });
          this.setPageLoaded({ key: "Challenges", value: false });
          this.$router.push({ name: "Challenges" });
        }
      });
    },

    async saveChanges() {
      if (!this.canEdit) {
        this.$router.push({
          name: "Challenge",
          params: { id: this.originalChallenge.id }
        });
      } else {
        const formData = new FormData();
        let numberOfChangedAttributes = 0;

        let attributes = [
          "name",
          "duration",
          "startDate",
          "dailyStepGoal",
          "open",
          "public",
          "allowActivities",
          "atStake",
          "featured",
          "incentivizeChallenge",
          "incentiveType",
          "incentiveAmount"
        ];
        if (this.isWellnessChallenge) {
          attributes.push("isTrackingTextAndImage", "isTrackingQuestions");
        }

        attributes.forEach(attribute => {
          let newValue = this.editedChallenge[attribute];

          if (!this.isOriginalValue(attribute, newValue)) {
            if (attribute === "duration") {
              attribute = "endDate";
              newValue = this.date(this.editedChallenge["endDate"]).formatted;
            }
            if (attribute === "startDate") {
              newValue = this.date(newValue).formatted;
            }
            if (attribute === "isTrackingQuestions") {
              attribute = "trackQuestionPoints";
            }
            if (attribute === "isTrackingTextAndImage") {
              attribute = "trackTextAndImagePoints";
            }

            formData.append(attribute, newValue);

            numberOfChangedAttributes++;
          }
        });

        const payload = {
          challengeId: this.originalChallenge.id,
          formData
        };

        this.saveInProgress = true;

        try {
          if (!this._.isEmpty(this.stagedMembers)) {
            if (this.includeByType === "invite") {
              await this.inviteChallengeEntities({
                recipientIds: this._.map(this.stagedMembers, "id"),
                challengeId: this.originalChallenge.id
              });
            }
            if (this.includeByType === "add") {
              await this.addEntitiesToChallenge({
                entityIds: this._.map(this.stagedMembers, "id"),
                challenge: this.editedChallenge
              });
            }
          }

          if (!this._.isEmpty(this.stagedTeams)) {
            if (this.includeByType === "invite") {
              await this.inviteChallengeEntities({
                teamIds: this._.map(this.stagedTeams, "id"),
                challengeId: this.originalChallenge.id
              });
            }
            if (this.includeByType === "add") {
              await this.addEntitiesToChallenge({
                entityIds: this._.map(this.stagedTeams, "id"),
                challenge: this.editedChallenge
              });
            }
          }
          // Refresh challenge entities/invites data
          this.includeEntityTableOpen = false;
          this.forceReloadOfChallengeEntities =
            this.forceReloadOfChallengeEntities + 1;
          // refresh teams table
          this.forceReloadOfTeamTable++;
          this.emptyStagedTeams();
        } catch (error) {
          this.updateChallengeError = true;
        }

        if (numberOfChangedAttributes > 0) {
          try {
            await this.updateChallenge(payload);
          } catch (error) {
            this.updateChallengeError = true;
          }
        }
        this.saveInProgress = false;
        this.isAdminEdit
          ? this.$router.push({ name: "ChallengeCenterSettings" })
          : this.$router.push({
              name: "Challenge",
              params: { id: this.originalChallenge.id }
            });
      }
    },

    onToggleInvites(event) {
      this.includeEntityTableOpen = event;
      if (!event) {
        if (this.originalChallenge.between === "individuals") {
          this.emptyStagedMembers();
        }
        if (this.originalChallenge.between === "groups") {
          this.emptyStagedTeams();
        }
      }
    },

    removeTeamCallback() {
      this.forceReloadOfTeamTable++;
    }
  },

  beforeRouteEnter(to, from, next) {
    next(async vm => {
      vm.fromRoute = from.name;
      // ensure that the challenge edit route is not accessed directly
      if (!from.name) {
        vm.$router.push({
          name: "Challenge",
          params: { id: +to.params.challengeId }
        });
      }
    });
  }
};
</script>

<style lang="sass" scoped>
#challenge-edit
  .challenge-edit-header
    width: 100%
  .card
    padding: 1.5rem
    margin-top: 1.5rem
    margin-bottom: 1.5rem
    overflow: visible
  .challenge-edit-form-controls
    margin-right: 1rem
    margin-left: 1rem
</style>
